<template>
  <modal-blank @close="$emit('close')">
    <div slot="body">
      <div>
        <!-- <h3 style="text-align: center; color:white">Preview</h3> -->
        <facebook-screen :pagename="selectedBot.pagename" @onScroll="onScroll">
          <div slot="body" style="position: relative">
            <template v-if="!isComment">
              <div v-if="questions && questions.length > 0">
                <div
                  class="message"
                  style="
                    margin-top: 10px;
                    margin-right: 10px;
                    margin-bottom: 10px;
                    float: right;
                    position: relative;
                    border-radius: 12px;
                    max-width: 181px;
                    overflow-wrap: break-word;
                    min-height: 22px;
                    min-width: 14px;
                    line-height: 15.36px;
                    overflow: hidden;
                  "
                >
                  <div style="font-size: 12px; color: white">
                    <div style="padding: 5px 8px 6px; background-color: #3578e5">
                      <span style="line-height: 15.36px">
                        <specialtext :text="questions[qustion_index]"></specialtext>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="clearfix"></div>
              </div>
            </template>
            <div
              v-if="messageData && messageData.length > 0"
              style="min-height: 300px; margin-top: 5px"
            >
              <div class="text-xs-left">
                <message-viewer v-model="messageData" :size="'small'" :show-profile="true" />

                <div class="clearfix"></div>
              </div>
            </div>
            <div style="margin-top: 70px"></div>
          </div>

          <div slot="footer">
            <div
              v-if="choice"
              v-show="isBottom"
              slot="quick_reply"
              style="position: relative; margin-top: 15px"
            >
              <div style="padding-bottom: 10px"></div>
              <div
                style="
                  padding-top: 10px;
                  padding-bottom: 10px;
                  margin: auto;
                  width: 100%;
                  text-align: center;
                  bottom: 0;
                  overflow-x: auto;
                  overflow-y: hidden;
                  height: 40px;
                  white-space: nowrap;
                "
              >
                <ul style="margin: auto; padding: 0">
                  <li
                    v-for="(reply, index) in choice"
                    :key="'reply_' + index"
                    style="
                      list-style-type: none;
                      display: inline;
                      padding: 5px 10px;
                      border: 1px solid #0284ff;
                      margin-right: 5px;
                      border-radius: 20px;
                      color: #0284ff;
                    "
                  >
                    {{ reply.text }}
                  </li>
                </ul>
              </div>
            </div>
            <div style="border-top: 1px solid #eee; margin-bottom: -7px">
              <img
                src="/static/img/assets/facebook_ui/iOS Composer Default.png"
                style="width: 100%"
                alt
              />
            </div>
          </div>
        </facebook-screen>
      </div>
    </div>
  </modal-blank>
</template>

<script>
import FacebookScreen from '@/components/elements/FacebookScreen'
import specialtext from '@/components/elements/specialtext'
import ModalBlank from '@/components/elements/ModalBlank'
import MessageViewer from '@/components/elements/MessageViewer'
import { mapGetters } from 'vuex'

export default {
  components: {
    FacebookScreen,
    specialtext,
    ModalBlank,
    MessageViewer
  },
  props: {
    messages: {
      default: [[]]
    },
    choice: {
      default: []
    },
    questions: {
      default: null
    },
    comment: {
      default: undefined
    },
    isComment: {
      default: false
    }
  },
  data: function () {
    return {
      qustion_index: 0,
      isBottom: true,
      previewMessageInterval: null,
      messageData: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomemessage: 'welcomeMessage',
      setting: 'setting'
    })
  },
  beforeDestroy: function () {
    clearInterval(this.previewMessageInterval)
  },
  mounted: function () {
    var vm = this
    if (vm.questions && vm.questions.length > 1) {
      vm.previewMessageInterval = setInterval(() => {
        if (vm.qustion_index === vm.questions.length - 1) {
          vm.qustion_index = 0
        } else {
          vm.qustion_index++
        }
      }, 5000)
    }

    vm.messageData = vm.messages
  },
  methods: {
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.isBottom = true
      } else {
        this.isBottom = false
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/PreviewMessage.vue